export default function(){return[].slice.call(arguments).map(function(e){return"object"==typeof e?(t=Object.entries(e),t.map(function(e){return e[1]?e[0]:""})).join(" "):e;var t}).join(" ").replace(/\s+/g," ").trim()}
//# sourceMappingURL=index.module.js.map
